import type { VideoComposition } from "./types";

/**
 * Return a copy of `composition` holding only the layers on screen at `frame`.
 *
 * For a still. `CompositionRoot` premounts every non-video layer for the whole
 * composition, so without this a one-frame render still mounts every caption,
 * animated SVG, and custom scene in the timeline — commonly nine of eleven
 * layers doing nothing. Array order is preserved, so the survivors keep their
 * relative z-order.
 *
 * Only for surfaces that render a fixed frame. A Player needs the layers it
 * has not reached yet.
 */
export function withOnlyLayersAtFrame(
  composition: VideoComposition,
  frame: number,
): VideoComposition {
  const filtered = composition.layers.filter(
    (layer) => layer.from <= frame && frame < layer.from + layer.duration,
  );
  if (filtered.length === composition.layers.length) return composition;
  return { ...composition, layers: filtered };
}
